export enum PlayerDominantHand {
  RIGHT = 'Right',
  LEFT = 'Left',
}
